import { useHistory } from 'react-router-dom';
import { MORE, MORE_EDIT_PERSONAL_DETAILS } from 'constants/shared/routes';
import PersonalDetails from '../presentational/PersonalDetails';
import DataCheck from 'components/shared/generic/dataCheck/presentational/DataCheck';
import PageContainer from 'components/shared/generic/pageContainer/presentational/PageContainer';
import SectionTitle from 'components/shared/generic/sectionTitle/presentational/SectionTitle';
import useTranslate from 'lib/languages/useTranslate';
import { PersonalDetailSection } from 'lib/type';
import { useGetAccountProfileQuery } from 'lib/services/account';

const PersonalDetailsContainer = () => {
    const { data, isLoading, error } = useGetAccountProfileQuery();

    const errorMessage = (error as { data, status })?.data?.message ?? "Something went wrong";

    const translate = useTranslate('personalDetails');
    const history = useHistory();

    const handleEditClick = (editPart: PersonalDetailSection) => {
        history.push(MORE_EDIT_PERSONAL_DETAILS, { editPart });
    };

    return (
        <PageContainer className="more-personal-details-container">
            <SectionTitle title={translate('titleText')} backRoute={MORE} />
            <DataCheck
                data={data}
                isLoading={isLoading}
                error={errorMessage}
                noDataMessage={translate('noDataMessage')}
            >
                <PersonalDetails
                    data={data}
                    editClick={(editPart: PersonalDetailSection) =>
                        handleEditClick(editPart)
                    }
                />
            </DataCheck>
        </PageContainer>
    );
};

export default PersonalDetailsContainer;
